(function (angular) {
  "use strict";

  angular.module('myApp').component('editProfile', {
    templateUrl: '/account/views/edit-profile.tpl.html',
    controller: 'EditProfileController'
  });

  angular.module('myApp').controller('EditProfileController', [
    '$scope', '$http', 'FileUploader', 'accountService', 'languageService', 'flash', '$state',
    function ($scope, $http, FileUploader, accountService, languageService, flash, $state) {
      $scope.aim = {};
      $scope.aim.dto = {};
      $scope.aim.dto.otp = '';
      $scope.aim.result = {};
      $scope.aim.result.errors = {};

      accountService.getAllResturantCategory().then(function (resp) {
        $scope.resturantCategory = resp.data;
      });
      languageService.getLanguages().then(function (resp) {
        $scope.languages = resp.data;
      });

      $scope.isDisableButton = false;
      $scope.tempUploadUrl = tempUploads;
      $scope.profileImageUploadUrl = memberProfileUpload;

      $scope.profileUploader = new FileUploader({url: "image-upload-filesize"});
      $scope.profileUploader.onAfterAddingFile = function (fileItem) {
        $scope.isDisableButton = true;
        fileItem.uploader.queue[0].upload();
      };
      $scope.profileUploader.onProgressItem = function (fileItem, progress) {
      };
      $scope.profileUploader.onCompleteItem = function (fileItem, response, status, headers) {
        if (response.success) {
          $scope.isDisableButton = false;
          $scope.aim.dto.logo = response.data.filePath + response.data.fileName;
        } else {
          $scope.aim.result.errors.logo = response.message;
          $scope.aim.dto.logo = '';
          $scope.isDisableButton = true;
        }
        if (this._directives.select[0].element[0].value !== undefined)
          this._directives.select[0].element[0].value = '';
        fileItem.uploader.clearQueue();
      };

      accountService.getEditProfile().then(function (resp) {
        $scope.aim.dto = resp.data;
        setTimeout(function () {
          funInputPlaceholder();
        }, 500);
      });

      $scope.submit = function () {
        accountService.editProfile($scope.aim.dto)
          .then(function (resp) {
            $scope.aim.result = resp.data;
            if (resp.data.success) {
              localStorage.removeItem("resturant");
              localStorage.setItem("resturant", resp.data.data);
              $state.go('menu');
              flash.show(resp.data.message, resp.data.messageType);
            }
          });
      };
      $scope.isGenerateOtp = false;
      $scope.sendOtpBtnText = 'Send OTP';
      $scope.generateOtp = function () {
        accountService.generateOtp($scope.aim.dto.mobileNumber).then(function (resp) {
          $scope.aim.result = resp.data;
          $scope.isGenerateOtp = resp.data.success;

          if ($scope.isGenerateOtp)
            $scope.sendOtpBtnText = 'Resend OTP';

          flash.show(resp.data.message, resp.data.messageType);
        });
      }

      $scope.verifyMobileNumber = function () {
        accountService.verifyMobileNumber({
          mobileNumber: $scope.aim.dto.mobileNumber,
          otp: $scope.aim.dto.otp
        }).then(function (resp) {
          console.log(resp.data);
          $scope.aim.dto = resp.data.data;
          flash.show(resp.data.message, resp.data.messageType);
        });
      }
    }
  ]);

}(window.angular));
